import { render } from "./MenuList.vue?vue&type=template&id=187cee0a&scoped=true"
import script from "./MenuList.vue?vue&type=script&lang=js"
export * from "./MenuList.vue?vue&type=script&lang=js"

import "./MenuList.vue?vue&type=style&index=0&id=187cee0a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-187cee0a"]])

export default __exports__